import React from 'react'

export const Icon = ({ src, width, height }) => {
  return <img src={src} width={width} height={height} />
}
